import Vue from "vue";
import Router from "vue-router";
import config from "@/config";

Vue.use(Router);

function redirectLobbyIfWhiteLabel(to, from, next) {
  if (config.whiteLabel == "1") {
    next({ path: "/prematch", replace: true });
    return;
  }
  next();
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/mobile",
      component: () => import("@/views/mobile/index.vue"),
      children: [
        // {
        //   name: "mobile",
        //   path: "/mobile",
        //   component: () => import("@/views/mobile/_home.vue"),
        //   meta: { requiredLoggedIn: true }
        // },
        {
          name: "lobby",
          path: "/lobby",
          component: () => import("@/views/mobile/_lobby.vue"),
          meta: { requiredLoggedIn: true },
          beforeEnter: redirectLobbyIfWhiteLabel
        },
        {
          name: "mybets",
          path: "/mybets",
          component: () => import("@/views/mobile/_my_bets.vue"),
          props: true,
          meta: { requiredLoggedIn: true }
        },
        {
          name: "my4dbets",
          path: "/my4dbets",
          component: () => import("@/views/mobile/_my_4dbets.vue"),
          props: true,
          meta: { requiredLoggedIn: true }
        },
        {
          name: "account",
          path: "/account",
          component: () => import("@/views/mobile/_account.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "highlight",
          path: "/highlight",
          component: () => import("@/views/mobile/_highlight.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "message",
          path: "/message",
          component: () => import("@/views/mobile/_message.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "settings",
          path: "/settings",
          component: () => import("@/views/mobile/_settings.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "settings-1",
          path: "/customize_sports_order",
          component: () => import("@/views/mobile/_customize_sports_order.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "contact_us",
          path: "/contact_us",
          component: () => import("@/views/mobile/_contact_us.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "betting_rules",
          path: "/betting_rules",
          component: () => import("@/views/mobile/_betting_rules.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "result",
          path: "/result",
          component: () => import("@/views/mobile/_result.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "sysparlay",
          path: "/sysparlay",
          component: () => import("@/views/mobile/_sysparlay.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "statement",
          path: "/statement",
          component: () => import("@/views/mobile/_statement.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "tnc",
          path: "/tnc",
          component: () => import("@/views/mobile/_tnc.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "parlaygenerator",
          path: "/parlaygenerator",
          component: () => import("@/views/mobile/_parlay_generator.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "allsports",
          path: "/allsports",
          component: () => import("@/views/mobile/_allsports.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "prematch",
          path: "/prematch",
          component: () => import("@/views/mobile/_prematch.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "more",
          path: "/more",
          component: () => import("@/views/mobile/_more.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "moreX",
          path: "/moreX",
          component: () => import("@/views/mobile/_moreX.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "select_league",
          path: "/select_league",
          component: () => import("@/views/mobile/_select_league.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-general",
          path: "/mobile/rules/page-betting-rules-general",
          component: () => import("@/views/mobile/rules/_page-betting-rules-general.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-general-market",
          path: "/mobile/rules/page-betting-rules-general-market",
          component: () => import("@/views/mobile/rules/_page-betting-rules-general-market.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-soccer",
          path: "/mobile/rules/page-betting-rules-soccer",
          component: () => import("@/views/mobile/rules/_page-betting-rules-soccer.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-basketball",
          path: "/mobile/rules/page-betting-rules-basketball",
          component: () => import("@/views/mobile/rules/_page-betting-rules-basketball.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-tennis",
          path: "/mobile/rules/page-betting-rules-tennis",
          component: () => import("@/views/mobile/rules/_page-betting-rules-tennis.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-esports",
          path: "/mobile/rules/page-betting-rules-esports",
          component: () => import("@/views/mobile/rules/_page-betting-rules-esports.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-baseball",
          path: "/mobile/rules/page-betting-rules-baseball",
          component: () => import("@/views/mobile/rules/_page-betting-rules-baseball.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-american-football",
          path: "/mobile/rules/page-betting-rules-american-football",
          component: () => import("@/views/mobile/rules/_page-betting-rules-american-football.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-athletics",
          path: "/mobile/rules/page-betting-rules-athletics",
          component: () => import("@/views/mobile/rules/_page-betting-rules-athletics.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-aussie-rules-football",
          path: "/mobile/rules/page-betting-rules-aussie-rules-football",
          component: () => import("@/views/mobile/rules/_page-betting-rules-aussie-rules-football.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-badminton",
          path: "/mobile/rules/page-betting-rules-badminton",
          component: () => import("@/views/mobile/rules/_page-betting-rules-badminton.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-bandy",
          path: "/mobile/rules/page-betting-rules-bandy",
          component: () => import("@/views/mobile/rules/_page-betting-rules-bandy.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-beach-soccer",
          path: "/mobile/rules/page-betting-rules-beach-soccer",
          component: () => import("@/views/mobile/rules/_page-betting-rules-beach-soccer.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-boxing",
          path: "/mobile/rules/page-betting-rules-boxing",
          component: () => import("@/views/mobile/rules/_page-betting-rules-boxing.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-cricket",
          path: "/mobile/rules/page-betting-rules-cricket",
          component: () => import("@/views/mobile/rules/_page-betting-rules-cricket.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-cycling",
          path: "/mobile/rules/page-betting-rules-cycling",
          component: () => import("@/views/mobile/rules/_page-betting-rules-cycling.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-darts",
          path: "/mobile/rules/page-betting-rules-darts",
          component: () => import("@/views/mobile/rules/_page-betting-rules-darts.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-field-hockey",
          path: "/mobile/rules/page-betting-rules-field-hockey",
          component: () => import("@/views/mobile/rules/_page-betting-rules-field-hockey.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-futsal",
          path: "/mobile/rules/page-betting-rules-futsal",
          component: () => import("@/views/mobile/rules/_page-betting-rules-futsal.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-gaelic-football",
          path: "/mobile/rules/page-betting-rules-gaelic-football",
          component: () => import("@/views/mobile/rules/_page-betting-rules-gaelic-football.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-golf",
          path: "/mobile/rules/page-betting-rules-golf",
          component: () => import("@/views/mobile/rules/_page-betting-rules-golf.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-handball",
          path: "/mobile/rules/page-betting-rules-handball",
          component: () => import("@/views/mobile/rules/_page-betting-rules-handball.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-hurling",
          path: "/mobile/rules/page-betting-rules-hurling",
          component: () => import("@/views/mobile/rules/_page-betting-rules-hurling.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-ice-hockey",
          path: "/mobile/rules/page-betting-rules-ice-hockey",
          component: () => import("@/views/mobile/rules/_page-betting-rules-ice-hockey.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-kabbadi",
          path: "/mobile/rules/page-betting-rules-kabbadi",
          component: () => import("@/views/mobile/rules/_page-betting-rules-kabbadi.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-mma",
          path: "/mobile/rules/page-betting-rules-mma",
          component: () => import("@/views/mobile/rules/_page-betting-rules-mma.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-motorsports",
          path: "/mobile/rules/page-betting-rules-motorsports",
          component: () => import("@/views/mobile/rules/_page-betting-rules-motorsports.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-muay-thai",
          path: "/mobile/rules/page-betting-rules-muay-thai",
          component: () => import("@/views/mobile/rules/_page-betting-rules-muay-thai.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-netball",
          path: "/mobile/rules/page-betting-rules-netball",
          component: () => import("@/views/mobile/rules/_page-betting-rules-netball.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-rugby",
          path: "/mobile/rules/page-betting-rules-rugby",
          component: () => import("@/views/mobile/rules/_page-betting-rules-rugby.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-sepak-takraw",
          path: "/mobile/rules/page-betting-rules-sepak-takraw",
          component: () => import("@/views/mobile/rules/_page-betting-rules-sepak-takraw.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-snooker",
          path: "/mobile/rules/page-betting-rules-snooker",
          component: () => import("@/views/mobile/rules/_page-betting-rules-snooker.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-squash",
          path: "/mobile/rules/page-betting-rules-squash",
          component: () => import("@/views/mobile/rules/_page-betting-rules-squash.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-table-tennis",
          path: "/mobile/rules/page-betting-rules-table-tennis",
          component: () => import("@/views/mobile/rules/_page-betting-rules-table-tennis.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-volleyball",
          path: "/mobile/rules/page-betting-rules-volleyball",
          component: () => import("@/views/mobile/rules/_page-betting-rules-volleyball.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-water-polo",
          path: "/mobile/rules/page-betting-rules-water-polo",
          component: () => import("@/views/mobile/rules/_page-betting-rules-water-polo.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-winter-sports",
          path: "/mobile/rules/page-betting-rules-winter-sports",
          component: () => import("@/views/mobile/rules/_page-betting-rules-winter-sports.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-4d-special",
          path: "/mobile/rules/page-betting-rules-4d-special",
          component: () => import("@/views/mobile/rules/_page-betting-rules-4d-special.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-sfv",
          path: "/mobile/rules/page-betting-rules-sfv",
          component: () => import("@/views/mobile/rules/_page-betting-rules-sfv.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-kof",
          path: "/mobile/rules/page-betting-rules-kof",
          component: () => import("@/views/mobile/rules/_page-betting-rules-kof.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-ufc",
          path: "/mobile/rules/page-betting-rules-ufc",
          component: () => import("@/views/mobile/rules/_page-betting-rules-ufc.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-vgames",
          path: "/mobile/rules/page-betting-rules-vgames",
          component: () => import("@/views/mobile/rules/_page-betting-rules-vgames.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-virtual-sports",
          path: "/mobile/rules/page-betting-rules-virtual-sports",
          component: () => import("@/views/mobile/rules/_page-betting-rules-virtual-sports.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-archery",
          path: "/mobile/rules/page-betting-rules-archery",
          component: () => import("@/views/mobile/rules/_page-betting-rules-archery.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-olympic",
          path: "/mobile/rules/page-betting-rules-olympic",
          component: () => import("@/views/mobile/rules/_page-betting-rules-olympic.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-winter-olympic",
          path: "/mobile/rules/page-betting-rules-winter-olympic",
          component: () => import("@/views/mobile/rules/_page-betting-rules-winter-olympic.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          name: "page-betting-rules-slots",
          path: "/mobile/rules/page-betting-rules-slots",
          component: () => import("@/views/mobile/rules/_page-betting-rules-slots.vue"),
          meta: { requiredLoggedIn: true }
        }
      ],
      meta: { requiredLoggedIn: true }
    },
    {
      path: "",
      component: () => import("@/views/m/index.vue"),
      children: [
        {
          path: "",
          component: () => import("@/views/m/_home.vue")
        },
        {
          path: "/home",
          component: () => import("@/views/m/_home.vue")
        }
      ]
    },
    {
      path: "/ngresult",
      component: () => import("@/views/game/ngresult.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/efresult",
      component: () => import("@/views/game/efresult.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/slots",
      component: () => import("@/views/game/slots.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/minigame",
      component: () => import("@/views/game/minigame.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/casino",
      component: () => import("@/views/game/casino.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/casinoLobby",
      component: () => import("@/views/game/casinoLobby.vue"),
      meta: { requiredLoggedIn: true },
    },
    {
      path: "/thirdparty",
      component: () => import("@/views/game/thirdparty.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/livetv",
      component: () => import("@/views/game/livetv.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/w4d",
      component: () => import("@/views/game/w4d.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/tournament",
      component: () => import("@/views/tournament/index.vue"),
      meta: { requiredLoggedIn: true },
      children: [
        {
          path: "/tournament",
          redirect: "/tournament/home",
          meta: { requiredLoggedIn: true },
        },
        {
          path: "/tournament/home",
          component: () => import("@/views/tournament/_home.vue"),
          meta: { requiredLoggedIn: true },
        },
        {
          path: "/roomCreate",
          component: () => import("@/views/tournament/_roomCreate.vue"),
          meta: { requiredLoggedIn: true },
        },
        // {
        //   path: "/roomJoin",
        //   component: () => import("@/views/tournament/_roomJoin.vue"),
        //   meta: { requiredLoggedIn: true },
        // },
      ],
    },
    {
      path: "/event",
      component: () => import("@/views/mobile/event/index.vue"),
      meta: { requiredLoggedIn: true }
    },
    {
      path: "/maintenance",
      component: () => import("@/views/common/_maintenance.vue")
    },
    {
      path: "*",
      component: () => import("@/views/common/_notFound.vue")
    }
  ]
});

export default router;
